<template>
    <div class="row ps-5">
        <div class="col-sm-5">
            <p class="font-weight-bold w-100 p-header lead p-2 mb-2">Sığorta şəhadətnaməsi</p>

            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">Müqavilə tarixi</td>
                    <td class="td-info-2">{{ data.policyDateStr }}</td>
                </tr>
                <tr>
                    <td class="td-info-1">Sığortalı</td>
                    <td class="td-info-2">{{ data.insuredName }}</td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Valyuta
                    </td>
                    <td class="td-info-2">
                        {{ data.currency }}
                    </td>
                </tr>
            </table>

            <p class="font-weight-bold mt-3 w-100 p-header lead mb-0 p-2 mb-1">Məsul şəxslər</p>

            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">
                        Agent
                    </td>
                    <td class="td-info-2" style="padding-left: 200px;">
                        {{ data.agentName }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Anderayter
                    </td>
                    <td class="td-info-2" style="padding-left: 200px;">
                        {{ data.underwritingName }}
                    </td>
                </tr>
                <tr>
                    <td class="td-info-1">
                        Kurator
                    </td>
                    <td class="td-info-2" style="padding-left: 200px;">
                        {{ data.curatorName }}
                    </td>
                </tr>
            </table>
        </div>

        <div class="col-sm-1"></div>
        <div class="col-sm-6 ">

            <p class="font-weight-bold p-header lead p-2 mb-2">Əlavə</p>

            <table class="table-info mt-2">
                <tr>
                    <td class="td-info-1">Tarix</td>
                    <td class="td-info-2">{{ data.addDateStr }}</td>
                </tr>
                <tr>
                    <td class="td-info-1">Nömrə</td>
                    <td class="td-info-2">{{ data.addNumber }}</td>
                </tr>
                <tr>
                    <td class="td-info-1">Buraxılıb</td>
                    <td class="td-info-2">
                        <i v-if="data.issued == true" style="font-size: 18px;" class="bi bi-check-lg text-excel"></i>
                    </td>
                </tr>
                <tr v-if="data.categoryId == 1">
                    <td class="td-info-1">Müddət</td>
                    <td class="td-info-2">{{ data.startDateStr }} - {{ data.endDateStr }}</td>
                </tr>
                <tr v-if="data.categoryId == 1">
                    <td class="td-info-1">Dəyişiklər</td>
                    <td class="td-info-2">{{ data.addTypeName }}</td>
                </tr>
                <tr v-if="data.categoryId == 1">
                    <td class="td-info-1">Kateqoriya</td>
                    <td class="td-info-2">{{ data.categoryName }}</td>
                </tr>
                <tr v-if="data.categoryId == 1">
                    <td class="td-info-1">Hesab faktura</td>
                    <td class="td-info-2">{{ dayjs(data.invoiceDate).format('DD.MM.YYYY') }}</td>
                </tr>
                <tr v-if="data.categoryId == 1">
                    <td class="td-info-1">Məzmun</td>
                    <td class="td-info-2">{{ data.description }}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
    data() {
        return {
            loading: false,
            dayjs,
            // fake data для prodleniya
            data: {
                policyDateStr: "15.03.2024",
                insuredName: "Orxan Məmmədov",
                addDateStr: "28.09.2025",
                addNumber: "Ə-2025/045",
                issued: true,
                currency: 'AZN',
                startDateStr: "15.03.2025",
                endDateStr: "15.03.2026",
                addTypeName: "Müddətin uzadılması",
                categoryId: 1,
                categoryName: "Müddətin uzadılması",
                invoiceDate: "2025-09-28",
                description: "Müştərinin müraciəti əsasında sığorta müddəti 1 il uzadıldı.",
                hSum: 1200,
                hCount: 3,
                hInsSum: 50000,
                fSum: 0,
                fCount: 0,
                fInsSum: 0,
                cSum: 0,
                agentName: "Vafa Abilova",
                underwritingName: "Elvin Rzayev",
                curatorName: "Samir Qasımov",
                cCount: 0,
                cInsSum: 0,
                totalSum: 1200,
                totalSumInsured: 50000
            }
        }
    }
}
</script>

<style scoped>
.td-info-1 {
    max-width: 370px;
    overflow: hidden;
    color: #495057;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
